module.exports = __webpack_public_path__ + "img/info-item-1.ed85c9da.png";